import type { PresetCustomPageConfig, PresetCustomPageIds } from '../../../types'
import { PageType } from '../../../types'
import { COVER_PAGE_ID, COVER_PAGE_PAGE_DESIGN } from './coverPage'
import { NEXT_STEPS_PAGE_DESIGN, NEXT_STEPS_PAGE_ID } from './nextSteps'

const CUSTOM_PAGE_AND_DESIGN: { [key in PresetCustomPageIds]: PresetCustomPageConfig } = {
  [COVER_PAGE_ID]: {
    type: PageType.PresetCustomPage,
    pageId: COVER_PAGE_ID,
    // grapejs design data
    design: COVER_PAGE_PAGE_DESIGN,
  },
  [NEXT_STEPS_PAGE_ID]: {
    type: PageType.PresetCustomPage,
    pageId: NEXT_STEPS_PAGE_ID,
    // grapejs design data
    design: NEXT_STEPS_PAGE_DESIGN,
  },
}

// SPLITTING AS INDIVIDUAL CHUNK, AWAIT DIRECT IMPORT RAW SETTING
export const CUSTOM_PAGE_CONFIGS: PresetCustomPageConfig[] = Object.values(CUSTOM_PAGE_AND_DESIGN)
